let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7HO6c")).then(() => parcelRequire('3JAdQ'));